import classNames from 'classnames';

import InternalMarkdown from '../../../app/shared/components/Markdown/Markdown';
import css from './Markdown.css';

type MarkdownProps = Pick<React.ComponentProps<typeof InternalMarkdown>, 'className' | 'content'>;

const Markdown = ({ className, ...props }: MarkdownProps) => {
  return <InternalMarkdown className={classNames(css.root, className)} {...props} />;
};

export default Markdown;
